<template>
  <div class="canvas-hints__wrapper">
    <img
      src="@/assets/images/hints/default.svg"
      alt="hints"
      class="hints__default-image"
      v-show="!hasAtLeastOneHint"
    >
    <div v-show="hasAtLeastOneHint" class="hints__image-wrapper">
      <swiper
        ref="canvasHintsSwiper"
        :options="swiperOptions"
      >
        <swiper-slide
          v-for="(hint, index) in slideActive.hints"
          :key="index"
        >
          <img
            src="@/assets/images/hints/canvas-hint-background.svg"
            alt="hints"
            class="hints__image"
            :class="{'is-presenting': isPresenting}"
          >
          <!-- <div
            class="hints__image-cropped-wrapper"
            :class="{'with-text': hint.title}"
            v-if="hint.imageCropped"
          >
            <img
              class="hints__image-cropped"
              :src="hint.imageCropped"
              alt="canvas-hint-image"
            />
          </div>
          <p class="hints__text" :class="{'with-image': hint.imageCropped }" v-if="hint.title">
            {{ hint.title || '' }}
          </p> -->
          <p class="hints__text" v-if="hint.title">
            {{ hint.title || '' }}
          </p>
        </swiper-slide>
        <aha-button
          slot="pagination"
          variant="link"
          class="text-sm font-bold swiper-btn-pagination swiper-button-prev"
          @click="handleNextBackHint('Back')"
        >
          <div class="prev-button__background" />
        </aha-button>
        <aha-button
          slot="pagination"
          variant="link"
          class="text-sm font-bold swiper-btn-pagination swiper-button-next"
          @click="handleNextBackHint('Next')"
        >
          <div class="next-button__background" />
        </aha-button>
        <!-- <div class="bottom-0 w-full swiper-pagination" slot="pagination"></div> -->
      </swiper>
      <div
        class="swiper-btn-close"
        v-if="isPresenting || isBackstage"
        @click="handleCloseCanvasHints()"
        :class="{'no-question-image': !slideActive.image}"
      >
        <aha-icon
          name="close"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          class="btn-close__icon"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import { Pagination } from 'swiper'
import EventBus from '@/eventBus'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import SlideApi from '@/api/slide'
import Socket from '@/socket'
import socketHelper from '@/helpers/socket/socket-helper'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  setup() {
    return {
      modules: [Pagination],
    }
  },
  data() {
    return {
      swiperOptions: {
        speed: 300,
        slidesPerView: 1,
        allowTouchMove: false,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletClass: 'swiper-custom-bullet',
          bulletActiveClass: 'swiper-custom-bullet-active',
          renderBullet(index, className) {
            return `<span class="${className}">•</span>`
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  computed: {
    ...mapGetters(['isPresenting', 'isBackstage']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    hasAtLeastOneHint() {
      return this.slideActive.hints && this.slideActive.hints.length &&
        this.slideActive.hints.some((hint) => hint.id)
    },
    swiper() {
      return this.$refs.canvasHintsSwiper ? this.$refs.canvasHintsSwiper.swiperInstance : null
    },
  },
  destroyed() {
    EventBus.$off('canvas-hints: jump-to-slide')
    EventBus.$off('canvas-hints: emit-to-audience')
    EventBus.$off('canvas-hints: close-from-backstage')
    EventBus.$off('canvas-hints: next-back-from-backstage')
  },
  mounted() {
    const self = this
    EventBus.$on('canvas-hints: jump-to-slide', (slideIndex) => {
      if (self.swiper) {
        setTimeout(() => {
          self.swiper.slideTo(slideIndex, 300, false)// next in 300ms
        }, 200)
      }
    })
    EventBus.$on('canvas-hints: emit-to-audience', () => {
      // data sent when first open hints
      if (self.swiper) {
        setTimeout(() => {
          this._sendHintDataToAudience(self.swiper.activeIndex)
        }, 200)
      }
    })
    EventBus.$on('canvas-hints: close-from-backstage', () => {
      this.handleCloseCanvasHints(true) // alreadyEmitSocketToPresenter
    })
    EventBus.$on('canvas-hints: next-back-from-backstage', (mode, swiperActiveIndex) => {
      this.handleNextBackHint(mode, swiperActiveIndex, true) // alreadyEmitSocketToPresenter
    })
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    handleNextBackHint(mode, swiperActiveIndex, alreadyEmitSocketToPresenter) {
      if (this.isPresenting || this.isBackstage) {
        if (alreadyEmitSocketToPresenter) {
          this.swiper.activeIndex = swiperActiveIndex
          this._sendHintDataToAudience(swiperActiveIndex)
        } else {
          const activeHintIndex = this._setActiveHintIndex(mode)
          this._sendHintDataToAudience(activeHintIndex)
          this.emitSocketBetweenPresenterAndBackstage(mode)
        }
      }
      Utils.mixpanelTracking(
        this.isPresenting ? eventCategories.PRESENTING_MODE : eventCategories.PRESENTATION_EDITOR,
        'Show hint',
        mode,
        '',
        {
          slideType: Utils.getCorrectSlideTypeName(this.slideActive.type,
            this.slideActive.slideType),
          slideId: this.slideActive.id,
          presentationId: this.presentation.id,
        },
      )
    },

    emitSocketBetweenPresenterAndBackstage(mode) {
      socketHelper.backstageControl({
        uniqueAccessCode: this.presentation.uniqueAccessCode,
        isForAudience: false,
        type: 'backstage-control: hints',
        data: {
          eventName: 'next-back-hints',
          mode,
          swiperActiveIndex: this._setActiveHintIndex(mode),
        },
      })
    },

    _setActiveHintIndex(mode) {
      let result
      if (mode === 'Next') {
        result = this.swiper.activeIndex + 1
      } else {
        result = this.swiper.activeIndex - 1
      }
      return result
    },

    handleCloseCanvasHints(alreadyEmitSocketToPresenter) {
      this.$emit('closeCanvasHints')
      this._sendHintDataToAudience(null)
      if (alreadyEmitSocketToPresenter) return
      socketHelper.backstageControl({
        uniqueAccessCode: this.presentation.uniqueAccessCode,
        isForAudience: false,
        type: 'backstage-control: hints',
        data: 'close-hints',
      })
    },

    _setNumberOfHintsAlreadyShown(hintsShowingIndex) {
      let { numberOfHintsShown } = this.slideActive
      const noHintsEverShown = !numberOfHintsShown && numberOfHintsShown !== 0
      const isOpenNewHint = hintsShowingIndex + 1 > numberOfHintsShown

      if (noHintsEverShown) {
        numberOfHintsShown = 1
      }
      if (!noHintsEverShown && isOpenNewHint) {
        numberOfHintsShown += 1
      }
      this.updateSlideActiveAction({
        numberOfHintsShown,
      })
      return numberOfHintsShown
    },

    _sendHintDataToAudience(hintsShowingIndex) {
      try {
        const numberOfHintsShown = this._setNumberOfHintsAlreadyShown(hintsShowingIndex)
        const payload = {
          socketId: Socket.getSocketId(),
          accessCode: this.presentation.uniqueAccessCode,
          hintsShowingIndex,
          numberOfHintsShown,
          presenting: true,
          isUpdateHint: true,
        }
        SlideApi.updateSlideById(this.slideActive.id, payload)
      } catch (error) {
        // handle error
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.canvas-hints__wrapper {
  position: absolute;
  top: 0;
  left: 50%;
  width: 800px;
  margin-left: -400px;
  z-index: 10;
  .hints__default-image {
    display: block;
    margin: 0 auto;
    max-width: 800px;
    width: 35%;
  }
  .hints__image-wrapper {
    position: relative;
    margin: 0 auto;
    max-width: 800px;
    width: 35%;
    &:hover {
      .swiper-button-prev, .swiper-button-next {
        opacity: 1;
        &.swiper-button-disabled {
          opacity: 0;
        }
      }
    }
    .hints__image {
      height: 158px;
      &.is-presenting {
        width: auto;
      }
    }
    .hints__image-cropped-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      &.with-text {
        height: 70%;
      }
      .hints__image-cropped {
        height: 100%;
        width: auto;
      }
    }
    .hints__text {
      position: absolute;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      font-size: 1.2em;
      padding: 1.5rem;
      font-weight: bold;
      color: #313131;
      word-break: break-word;
      &.with-image {
        height: 30%;
        top: 70%;
      }
    }
  }
}
.swiper-slide {
  -webkit-transform: translate3d(0, 0, 0);
}
.swiper-button-next {
  right: 0;
}
.swiper-button-prev {
  left: 0;
}
.swiper-button-prev, .swiper-button-next {
  position: absolute;
  top: 0;
  min-width: 3.5rem;
  z-index: 999;
  height: 100%;
  padding: 0;
  opacity: 0;
  transition: opacity 0.2s ease-in;
  &:hover {
    &:after {
      color: #348EF6;
    }
  }
  &:after {
    font-size: 0.8em;
    color: #313131;
    font-weight: bold;
    position: relative;
    z-index: 1;
  }
  &.swiper-button-disabled {
    opacity: 0;
  }
}
.swiper-button-next:after {
  margin-left: 3px;
}
.swiper-button-prev:after {
  margin-right: 2px;
}
.prev-button__background, .next-button__background {
  width: 30px;
  height: 30px;
  position: absolute;
  background: #ffffff;
  border: 2px solid #ffb12e;
  border-radius: 2rem;
}
.swiper-pagination ::v-deep {
  .swiper-custom-bullet {
    color: rgba(10, 10, 10, 0.3);
    &.swiper-custom-bullet-active {
      color: rgba(10, 10, 10, 0.7);
    }
  }
}
.swiper-btn-close {
  position: absolute;
  top: 0;
  margin-top: -0.5rem;
  right: -0.5rem;
  background: #ffffff;
  z-index: 1;
  border: 1px solid #FFB12E; // yellow-50
  border-radius: 2rem;
  color: #313131;
  width: 27px;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    .btn-close__icon {
      color: #348EF6;
    }
  }
  &.no-question-image {
    top: 0;
  }
}
</style>
